// extracted by mini-css-extract-plugin
export default {"bottomNavigation":"bottomNav_bottomNavigation__EE2lO","item":"bottomNav_item__CpyAf","active":"bottomNav_active__-u9kN"};